import { styled } from 'styled-components';

export const FormContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.marginLG}px;
    
    .ant-form {
      width: 100%;
    }
  `}
`;

export const FormField = styled.div`
  ${({ theme }) => `
    .ant-form-item {
      margin-bottom: ${theme.marginLG}px;
    }
    
    .ant-form-item-label {
      padding-bottom: ${theme.paddingXS}px;
      
      label {
        font-weight: ${theme.fontWeightStrong};
        color: ${theme.colorText};
      }
    }
    
    .ant-input,
    .ant-input:focus,
    .ant-input-focused {
      border-color: ${theme.colorBorder};
      box-shadow: none;
      
      &:hover {
        border-color: ${theme.colorPrimary};
      }
      
      &:focus {
        border-color: ${theme.colorPrimary};
        box-shadow: 0 0 0 2px ${theme.colorPrimary}1a;
      }
    }
    
    .ant-input[readonly] {
      background-color: ${theme.colorBgContainer};
      color: ${theme.colorTextDisabled};
      cursor: not-allowed;
    }
  `}
`;

export const ActionButtonsContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: flex-end;
    gap: ${theme.marginSM}px;
    padding-top: ${theme.paddingLG}px;
    border-top: 1px solid ${theme.colorBorderSecondary};
    margin-top: ${theme.marginLG}px;
    
    .ant-btn {
      min-height: ${theme.controlHeight}px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${theme.marginXXS}px;
    }
  `}
`;

export const ErrorMessage = styled.div`
  ${({ theme }) => `
    padding: ${theme.paddingSM}px;
    background-color: ${theme.colorErrorBg};
    border: 1px solid ${theme.colorErrorBorder};
    border-radius: ${theme.borderRadius}px;
    margin-bottom: ${theme.marginMD}px;
    
    .ant-typography {
      margin: 0;
      font-size: ${theme.fontSizeSM}px;
    }
  `}
`;